export default __webpack_public_path__ + "static/p1-433dfed1e3faf1ca263e186b3ac8097a.jpg";